
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "688b54b1-ff12-426b-bdc0-fa9172a79d7d"
  },
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoiZWlpcyIsImEiOiJjbWV3d25zZG0wdncyMmlxeGRqbGd1ajJpIn0.zgwy8hi4SStt0eSALEb8fw"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
